import { useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Activity, Loader2 } from "lucide-react";

export default function MotorHealth() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const run = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/motor/health"); setData(data); }
    finally { setLoading(false); }
  };
  return (
    <div className="space-y-6" data-testid="motor-health-page">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Stato Motore — Checklist go-live</h1>
          <p className="text-muted-foreground mt-1 text-sm">Controlla connessione, schema, brand e accesso SSO prima di pubblicare in produzione.</p>
        </div>
        <button onClick={run} disabled={loading} className="bg-[#E3FF00] text-neutral-900 font-semibold px-4 py-2.5 rounded-lg hover:brightness-95 flex items-center gap-2 disabled:opacity-60 shrink-0" data-testid="motor-health-run">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Activity className="h-4 w-4" />} Esegui controllo
        </button>
      </div>

      {data && (
        <>
          <div className={`rounded-xl border-2 p-4 font-semibold ${data.ok ? "border-emerald-500 bg-emerald-500/10 text-emerald-700" : "border-rose-500 bg-rose-500/10 text-rose-700"}`} data-testid="motor-health-overall">
            {data.ok ? "✓ Tutti i controlli superati — pronto per il go-live" : "✗ Alcuni controlli non superati — risolvi prima di pubblicare"}
          </div>
          <div className="bg-card rounded-xl border border-border/80 divide-y divide-border/60">
            {data.checks.map((c) => (
              <div key={c.key} className="flex items-center justify-between gap-3 px-4 py-3" data-testid={`motor-check-${c.key}`}>
                <div className="flex items-center gap-3 min-w-0">
                  {c.ok ? <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" /> : <XCircle className="h-5 w-5 text-rose-600 shrink-0" />}
                  <span className="font-medium">{c.label}</span>
                </div>
                <span className="text-xs text-muted-foreground font-mono-data truncate max-w-[50%]">{c.detail}</span>
              </div>
            ))}
          </div>
          <p className="text-xs text-muted-foreground">Base URL motore: <span className="font-mono-data">{data.base_url}</span></p>
        </>
      )}
      {!data && !loading && <p className="text-sm text-muted-foreground">Premi "Esegui controllo" per avviare la verifica.</p>}
    </div>
  );
}
